<h1>Enrolled</h1>

<section>
<p>You have been successfully enrolled.
<p><a href="/status-enrolled">Enrollment Details</a>
</section>
